var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.16 12C22.16 17.6112 17.6112 22.16 12 22.16C6.38879 22.16 1.84 17.6112 1.84 12C1.84 6.38879 6.38879 1.84 12 1.84C17.6112 1.84 22.16 6.38879 22.16 12Z",
    stroke: "#95A4AD",
    strokeWidth: 1.68
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7C9.792 7 8 8.79439 8 11.0053C8 13.1736 9.696 14.9359 11.9467 15C11.9787 15 12.0213 15 12.0427 15C12.064 15 12.096 15 12.1173 15C12.128 15 12.1387 15 12.1387 15C14.2933 14.9252 15.9893 13.1736 16 11.0053C16 8.79439 14.208 7 12 7Z",
    fill: "#95A4AD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 20.0993C17.1622 21.8944 14.705 23 12 23C9.29499 23 6.83776 21.8944 5 20.0993C5.24779 19.1032 5.91888 18.1947 6.89971 17.4941C9.71829 15.502 14.3024 15.502 17.1003 17.4941C18.0914 18.1947 18.7522 19.1032 19 20.0993Z",
    fill: "#95A4AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.c03d271f9af8838958ab55e34c79203e.svg";
export { ForwardRef as ReactComponent };